import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/BoardArticles.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // 사이트관리
  {
    // ACL: ROOT, BUSINESS
    path: '/businesses',
    name: '운영자관리', // 구. 운영자관리
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesses" */ '../views/Businesses.vue')
  },
  {
    // ACL: ROOT, BUSINESS
    path: '/businesses/class',
    name: '클래스관리', // 구. 운영자관리
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesses" */ '../views/bizClass.vue')
  },
  {
    // ACL: Type 상관없이 그 캠퍼스의 슈퍼유저만 사용가능
    path: '/admins',
    name: '관리계정 관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessadmin" */ '../views/adminAccount.vue')
  },
  {
    // ACL: Type 상관없이 그 캠퍼스의 슈퍼유저만 사용가능
    path: '/admins/tutor',
    name: '관리계정 관리 클래스담당',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessadmin" */ '../views/tutorAdmin.vue')
  },
  // TODO: 팝업관리, 배너관리
  {
    // ACL: ROOT
    path: '/products/accounts',
    name: '쇼핑몰->아이디관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessproduct" */ '../views/Products.vue')
  },
  {
    // ACL: ALL
    path: '/popups',
    name: '운영자관리->팝업관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "popups" */ '../views/Popups.vue')
  },
  {
    // ACL: ALL
    path: '/banner',
    name: 'CAMPUS 게시판->배너관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "popups" */ '../views/banner.vue')
  },
  {
    // ACL: ALL
    path: '/boards/',
    name: '게시판관리->게시판목록',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardList.vue')
  },
  {
    // ACL: ALL
    path: '/boards/:boardId',
    name: '게시판관리->게시판 상세설정',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "boardsettings" */ '../views/BoardSettings.vue')
  },
  {
    // ACL: ALL
    path: '/boards/files/articles',
    name: '게시판관리->게시판 글(학습게시판only)',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticlesFiles.vue')
  },
  {
    // ACL: ALL
    path: '/boards/teacher/articles',
    name: '게시판관리->게시판 글(숙제게시판only)',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticlesTeacher.vue')
  },
  {
    // ACL: ALL
    path: '/boards/banner/articles',
    name: '게시판관리->게시판 글(캠퍼스 배너관리)',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticlesBanner.vue')
  },
  {
    // ACL: ALL
    path: '/boards/enterprise/articles',
    name: '게시판관리->게시판 글(학원게시판)',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticlesEnterprise.vue')
  },

  {
    // ACL: ALL
    path: '/boards/:board/articles',
    name: '게시판관리->게시판 글',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticles.vue')
  },
  {
    // ACL: ALL
    path: '/boards/:board/articles/:article',
    name: '게시판관리->게시판 글 읽기',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardReadArticles.vue')
  },
  {
    // ACL: ALL
    path: '/boards/files/articles/new',
    name: '게시판관리->게시판 글 작성(자료실)',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardWriteFiles.vue')
  },
  {
    // ACL: ALL
    path: '/boards/:board/articles/new',
    name: '게시판관리->게시판 글 작성',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardWrite.vue')
  },
  {
    // ACL: ALL
    path: '/boards/:board/articles/:article/edit',
    name: '게시판관리->게시판 글 수정',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "board" */ '../views/BoardWrite.vue')
  },
  {
    // ACL: ALL
    path: '/ims/history',
    name: '문자발송내역',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ims" */ '../views/IMSHistory.vue')
  },
  {
    // ACL: ALL
    path: '/avatar/userList',
    name: '아바타 사용자 현황',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ims" */ '../views/Avatar_userList.vue')
  },

  // 기관관리

  {
    // ACL: ROOT
    path: '/businesses/local',
    name: '본부별관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesslocal" */ '../views/BusinessLocalView.vue')
  },
  {
    // ACL: ROOT, LOCAL
    path: '/businesses/campuses',
    name: '캠퍼스관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesscampuses" */ '../views/BusinessCampusView.vue')
  },

  // 회원관리 - view는 하나로 통합 후 v-if로 분기
  // ACL: ROOT, BUSINESS, CLASS
  {
    path: '/classes',
    name: '클래스목록',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessclasses" */ '../views/Classes.vue')
  },
  {
    path: '/students',
    name: '회원뷰',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessstudents" */ '../views/Students.vue')
  },

  //회원관리 -> 학습점수관리 -> 회원학습현황
  {
    path: '/students/pointmgr/memberlist',
    name: '회원학습현황',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessstudents" */ '../views/PointMemList.vue')
  },

  //회원관리 -> 학습점수관리 -> 학습점수내역역
  {
    path: '/students/pointmgr/pointlist',
    name: '학습점수내역',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessstudents" */ '../views/PointList.vue')
  },



  // 주문관리
  // 전체 ROOT, LOCAL, BUSINESS

  {
    path: '/products',
    name: '아이디',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businessproducts" */ '../views/Products.vue')
  },

  {
    path: '/subscriptions',
    name: '주문내역->아이디',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/Subscriptions.vue')
  },

  {
    path: '/product_manage',
    name: '주문관리->상품관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/product_manageN.vue')
  },

  // 학습관리
    {
    path: '/report',
    name: '마이패스리포트->리포트',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/report.vue')
  },



  // 음성게시판 관리
    {
    path: '/voice',
    name: '학습관리->음성게시판 관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/voice.vue')
  },


  // 마이패스 레벨테스트
    {
    path: '/mypath_test',
    name: '마이패스 레벨테스트->레벨테스트 결과지',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/mypath_test.vue')
  },



  {
    path: '/studies/homework',
    name: '진도관리->숙제관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/homework_list.vue')
  },
  {
    path: '/studies/homework_new',
    name: '진도관리->숙제 관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/homework_new.vue')
  },

  {
    path: '/studies/american',
    name: '진도관리->미국학습',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/USProgressN.vue')
  },
  {
    path: '/studies/progress_report_old',
    name: '진도관리->차일드유progress report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/progress_report_old.vue')
  },
  {
    path: '/studies/progress_report',
    name: '진도관리->New progress report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/progress_reportN.vue')
  },
/*
  {
    path: '/studies/american_t',
    name: '진도관리->미국학습_t',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" / '../views/USProgress_t.vue')
  },
*/

  {
    path: '/studies/languageList',
    name: '진도관리->언어훈련',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/LanguageList.vue')
  },
  {
    path: '/homework/american',
    name: '숙제관리->미국학습',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/HomeUSProgress.vue')
  },

  {
    path: '/studies/language',
    name: '숙제관리->언어훈련',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/Languages.vue')
  },
  {
    path: '/studies/language_new',
    name: '숙제관리->언어훈련_new',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/Languages_new.vue')
  },
  {
    path: '/studies/languageA',
    name: '숙제관리->언어훈련ALS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/Languages_als.vue')
  },
  {
    path: '/studies/homeworkA',
    name: '진도관리->숙제관리ALS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/homework_als.vue')
  },


  {
    path: '/studies/americanA',
    name: '진도관리->진도관리ALS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "progress" */ '../views/USProgress_als.vue')
  },
//힘들어서 여기서 정지 .......터치
{
  path: '/studies/manager_grade',
  name: '학습변경관리',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "studymanager" */ '../views/manager_grade.vue')
},
{
  path: '/studies/leveltest',
  name: '진도관리->레벨테스트',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/leveltest.vue')
},
{
  path: '/studies/manager_leveltest',
  name: '진도관리->레벨테스트 결과관리',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/manager_leveltestN.vue')
},
{
  path: '/studies/alstest',
  name: '진도관리->레벨테스트1',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/PlacementTest.vue')
},
{
  path: '/studies/manager_alstest',
  name: '진도관리->레벨테스트 결과관리1',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "businesssubscription" */ '../views/manager_PlacementTest.vue')
},
{
  path: '/studies/manager_score',
  name: '학습 점수 관리',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "studymanager" */ '../views/N_scores.vue')
},
{
  path: '/studies/manager_uracle',
  name: '유라클관리',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "studymanager" */ '../views/manager_uracle.vue')
},
{
  path: '/pay_head',
  name: '수수료(본부)',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "financials" */ '../views/pay_head.vue')
}
,
{
  path: '/pay_campus',
  name: '수수료(캠퍼스)',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "financials" */ '../views/pay_campusN.vue')
}
,
{
  path: '/pay_list',
  name: '수수료(캠퍼스_회원리스트)',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "financials" */ '../views/pay_list.vue')
}
,
{
  path: '/requests/franchise_meetings/plans',
  name: '사업설명회일정',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "requests" */ '../views/requestsFranchiseMeetingsPlans.vue')
}
,
{
  path: '/requests/franchise_meetings/plans/:plan_id/attendants',
  name: '사업설명회신청자_1',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "requests" */ '../views/requestsFranchiseMeetingsAttendants.vue')
}
,
{
  path: '/requests/franchise_meetings/attendants',
  name: '사업설명회신청자_2',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "requests" */ '../views/requestsFranchiseMeetingsAttendants.vue')
}
,
{
  path: '/events/2022_Winter',
  name: '2022학습이벤트 신청',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/event_2022_summer.vue')
},
{
  path: '/events/learningreview',
  name: '2022학습이벤트 후기',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/Learning_Review.vue')
},
{
  path: '/events/view',
  name: '2022학습이벤트 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/event_study.vue')
},
{
  path: '/events/2023_Summer',
  name: '2023 여름방학 학습이벤트 신청',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023_summer.vue')
},
{
  path: '/events/2023_Summer_learningreview',
  name: '2023 여름방학 학습이벤트 후기',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023s_Review.vue')
},
{
  path: '/events/2023_Summer_view',
  name: '2023 여름방학 학습이벤트 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023s_study.vue')
},
{
  path: '/events/2023_Winter',
  name: '2023 겨울방학 학습이벤트 신청',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023_winter.vue')
},
{
  path: '/events/2023_Winter_learningreview',
  name: '2023 겨울방학 학습이벤트 후기',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023w_Review.vue')
},
{
  path: '/events/2023_Winter_view',
  name: '2023 겨울방학 학습이벤트 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023w_study.vue')
},
{
  path: '/events/2024_Summer',
  name: '2024 여름방학 학습이벤트 신청',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024_summer.vue')
},
{
  path: '/events/2024_Summer_view',
  name: '2024 여름방학 학습이벤트 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024s_study.vue')
},
{
  path: '/events/2024Summer',
  name: '2024 여름방학 학습이벤트 게시판',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024s_Review.vue')
},
{
  path: '/events/2024_Winter',
  name: '2024 겨울방학 학습이벤트 신청',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024_winter.vue')
},
{
  path: '/events/2024_Winter_view',
  name: '2024 겨울방학 학습이벤트 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024w_study.vue')
},
{
  path: '/events/2024Winter',
  name: '2024 겨울방학 학습이벤트 게시판',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024w_Review.vue')
},
{
  path: '/events/2024Winter/history',
  name: '2024 겨울방학 게임참여현황 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024w_EventHistory.vue')
},

/* 2025년 여름방학 어학연수 */
{
  path: '/events/2025_Summer',
  name: '2025 여름방학 학습이벤트 신청',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2025_summer.vue')
},
{
  path: '/events/2025_Summer_view',
  name: '2025 여름방학 학습이벤트 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2025s_study.vue')
},
{
  path: '/events/2025Summer',
  name: '2025 여름방학 학습이벤트 게시판',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2025s_Review.vue')
},
{
  path: '/events/2025Summer/history',
  name: '2025 여름방학 게임참여현황 현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2025s_EventHistory.vue')
},
{
  // ACL: ALL
  path: '/events/:board/new',
  name: '이벤트 게시판관리->게시판 글 작성',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticlesEventWrite.vue')
},
{
  // ACL: ALL
  path: '/events/:board/:article/edit',
  name: '이벤트 게시판관리->게시판 글 수정',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/BoardArticlesEventWrite.vue')
},

{
  // ACL: ALL
  path: '/events/:board/:article',
  name: '이벤트 게시판관리->게시판 글 읽기',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/EventBoardReadArticles.vue')
},
{
  // ACL: ALL
  path: '/events/:board/history',
  name: '이벤트 게시판관리->게임참여현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2024s_EventHistory2.vue')
},
{
  // ACL: ALL
  path: '/event/review/:article',
  name: '2022학습이벤트->후기읽기',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/ReviewArticles.vue')
},
{
  // ACL: ALL
  path: '/event/2023s_Review/:article',
  name: '2022학습이벤트->후기읽기',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/2023s_ReviewArticles.vue')
},
{
  path: '/events/recommender',
  name: '친구추천 이벤트',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "board" */ '../views/Recommender.vue')
},
{
  path: '/parking',
  name: 'Parking',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "parking" */ '../views/parking.vue')
},
{
  // ACL: ALL
  path: '/stat_fr',
  name: '통계관리->가맹',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_fr.vue')
},
{
  // ACL: ALL
  path: '/stat_fr_new',
  name: '통계관리->아이디 사용현황',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_fr_new.vue')
}
,
{
  // ACL: ALL
  path: '/stat_sales',
  name: '통계관리->매출',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_sales.vue')
}
,
{
  // ACL: ALL
  path: '/stat_sales_new',
  name: '통계->매출',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_sales_new.vue')
}
,
{
  // ACL: ALL
  path: '/stat_id',
  name: '통계관리->아이디',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_id.vue')
}
,
{
  // ACL: ALL
  path: '/stat_id_new',
  name: '통계->아이디',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_id_new.vue')
}
,
{
  // ACL: ALL
  path: '/stat_textbook',
  name: '통계관리->교재',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/stat_textbook.vue')
}
,
{
  // ACL: ALL
  path: '/sample_button',
  name: '통계관리->교재',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "popups" */ '../views/sample_button.vue')
}
,

  //자동연장관리 (스케줄러가 정상작동했는지 여부확인)  
  {
    // ACL: ALL
    path: '/subscription_auto',
    name: '자동주문연장관리',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "popups" */ '../views/subscription_auto.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
